import { HttpClient } from '@angular/common/http';
import { Component, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DemoService } from './../../demo.service';
import { GlobalFunctionsService } from './../../services/global-functions.service';
import { MysqlService } from './../../services/mysql.service';
import { BsModalService } from 'ngx-bootstrap';
import { Observable } from 'rxjs';
import { HotToastService } from '@ngneat/hot-toast';
@Component({
  selector: 'app-lost-password',
  templateUrl: './lost-password.component.html',
  styleUrls: ['./lost-password.component.css']
})
export class LostPasswordComponent implements OnInit {
  expiry_token: string;
  model: any = {};
  user_id: any;
  modalRef: any;
  userMysql: any;
  expiry_token_date: any;
  stored_expiry_token: any;
  metric_1_date_1: Date;
  metric_1_date_2: Date;
  expiry_token_date_valid: number;
  expiry_token_valid: number;

  constructor(
    public gfunc: GlobalFunctionsService,
    private _mysqlService: MysqlService,
    private route: ActivatedRoute,
      private router: Router,
      private http: HttpClient,
      private _demoService: DemoService,
      private toastr: HotToastService,
      vcr: ViewContainerRef,
      private modalService: BsModalService,
  ) {
   
    this.expiry_token = this.route.snapshot.paramMap.get('expiry_token');
    this.user_id = this.route.snapshot.paramMap.get('user_id');

   }

  ngOnInit() {

if(this.user_id > 0){
const user = [{
user_id: this.user_id
}];
 this.getMysqlUser(user, this.user_id);
}


console.log('User: ID:' , this.user_id);
console.log('Taken:' , this.expiry_token);


}

// Make dumb component as it open to public.

verifyUserSendResetRequest(model){
  // get User Details and confirm
  // do a global function to get and verify user


// do the data checking.... gets user and checks, sets and updates reset_token+date as well as link in email
  this._mysqlService.verifyUserSendResetRequest(model).subscribe(
    (data) => {
      // this.trace_candidate_update = data;

      const res = data;
      console.log(res as string); // not working as response is showing in body
      // console.log(res._body);
      // console.log(res[0].text()); // Convert response to a string
      // this.user_id = res.text();
      // this.subjectChangeDates(model, this.subject_id);
      // this.gfunc.onOpenDialog_SuccessCommunication(event, model);

        // if(res[0].text() === 'INVALID') {
        //   alert('FAILED: Please Try Again.');
        //   this.toastr.error('credentials are not correct match!.');
        // }

        // if(res[0].text() !== 'INVALID') {
        //   alert('Success: Please check your Inbox, for a password reset email.');
        //   this.toastr.success('Verifing... Sending you an email.');
        //   this.gfunc.login();
        //   // log this action?
        // }



        if(res as string === 'INVALID') {
          alert('FAILED: Please Try Again.');
          this.toastr.error('credentials are not correct match!.');
        }

        if(res as string  !== 'INVALID') {
          alert('Success: Please check your Inbox, for a password reset email.');
          this.toastr.success('Verifing... Sending you an email.');
          this.gfunc.login();
          // log this action?
        }



    },
    (error) => {
      this.toastr.error('Error with your information! Try Again.');
      return console.log(error);
    }
  );




  // Create New Password from link.



  // send the email + do data updates in php - reset_token and reset_token_date? now or timestamp?



}



getMysqlUser(model, user_id) {
  this._mysqlService.getMysqlUser(model, user_id)
    .subscribe(
      (res) => {
        
console.log('Extiry Response: ', JSON.parse(res));
const dat = res;

        this.userMysql = JSON.parse(res);
        this.expiry_token_date = this.userMysql[0].expiry_token_date;
        this.stored_expiry_token = this.userMysql[0].expiry_token;

        console.log('Extiry Toke date: ', this.userMysql[0].expiry_token_date);
        console.log('Extiry Toke Stored: ', this.stored_expiry_token);

                    // DATE CHECKER
                    // ::@ https://programmingwithswift.com/how-to-compare-dates-with-typescript/
                    // this.metric_1_date_1 = new Date(this.metric_1_data[0].created_date * 1000);
                    // this.metric_1_date_2 = new Date(this.metric_1_data[0].date_service);
                    this.metric_1_date_1 = new Date(this.gfunc.today);
                    this.metric_1_date_2 = new Date(this.expiry_token_date);

                      
                          // DID NOW WOK ON TIME SEE BELOW FUNCTION COMPARISON.
                          // 3. Greater than check - checks if date has not expired.
                    // if (this.metric_1_date_1 <= this.metric_1_date_2) {
                    //   console.log('Token is valid is is still valid:');
                    //   this.expiry_token_date_valid = 1;
                    // } else {
                    //   console.log('Token expired, please request a new link');
                    //   this.expiry_token_date_valid = 0;
                    // }

                    const myDate = new Date(); // today
                    if (this.metric_1_date_1 > this.metric_1_date_2) {
                        console.log('Token date is valid:');
                      this.expiry_token_date_valid = 1;
                    } else {
                          console.log('Token expired, please request a new link');
                      this.expiry_token_date_valid = 0;
                    }


                    // token checker - checks if tokens match
                    if (this.stored_expiry_token == this.expiry_token) {
                      console.log('Token is valid:');
                      this.expiry_token_valid = 1;
                    } else {
                      console.log('Token Invalid, please request again');
                      this.expiry_token_valid = 0;
                    }


                    // ::@ https://stackoverflow.com/questions/64052548/how-to-check-selected-time-is-less-than-current-or-greater-than-current-time-usi
                    const dateString = '2020-09-24T16:57:23.985Z';
                    console.log('current time is greater', new Date().getTime() > new Date(this.metric_1_date_2).getTime());


      },
      (err) => console.log(err)
    );
}





   // MODAL
  // start of modal windows service as a template
  openModal(template: TemplateRef<any>) {
    // small upgrade to disable background click on open modal background
    const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
    this.modalRef = this.modalService.show(template, config);
  }

    // :: Parent / Child modal test
    closeParentModel() {
      // alert('parent component function.');
      this.modalRef.hide();
     // this.refreshGrid(); // resets the grid if updated and closed.
    //  this.updateTypeClick = false; // closes the div
    };
    
  

}
